<div class="documentations-container">
  <!-- Formulário de Documentação (Standalone) -->
  <teo-wiki-documentation-form #documentationForm> </teo-wiki-documentation-form>

  <!-- Cabeçalho com botão de adicionar -->
  <div class="mb-3 d-flex justify-content-between align-items-center">
    <h5 class="mb-0">Documentações Vinculadas</h5>
    @if (canWrite) {
      <patron-button
        iconName="bi-plus-circle"
        color="primary"
        size="sm"
        (onClick)="openNewDocumentation()">
        Nova Documentação
      </patron-button>
    }
  </div>

  <!-- Tabela de documentações -->
  @if (!loading && documentations.length > 0) {
    <div class="table-responsive">
      <table class="table table-hover table-sm">
        <thead class="table-light">
          <tr>
            <th>Título</th>
            <th>Categoria</th>
            <th>Visibilidade</th>
            <th>Criada em</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          @for (doc of documentations; track doc) {
            <tr>
              <td>
                <strong>{{ doc.title }}</strong>
                <br />
                <small class="text-muted">{{ doc.slug }}</small>
              </td>
              <td>
                <patron-badge
                  [color]="
                    doc.category === 'technical'
                      ? 'info'
                      : doc.category === 'user_manual'
                        ? 'success'
                        : 'warning'
                  "
                  size="sm">
                  {{ doc.category }}
                </patron-badge>
              </td>
              <td>
                <patron-badge
                  [color]="
                    doc.visibility === 'public'
                      ? 'success'
                      : doc.visibility === 'private'
                        ? 'danger'
                        : 'warning'
                  "
                  size="sm">
                  {{ doc.visibility }}
                </patron-badge>
              </td>
              <td>
                <small>{{ doc.created_at | date: 'dd/MM/yyyy HH:mm' }}</small>
              </td>
              <td class="text-center">
                <div class="d-flex gap-1 justify-content-center">
                  <patron-button
                    iconName="bi-eye"
                    size="sm"
                    color="info"
                    variant="outline"
                    title="Visualizar"
                    (onClick)="viewDocumentation(doc)">
                  </patron-button>
                  @if (canWrite) {
                    <patron-button
                      iconName="bi-pencil"
                      size="sm"
                      color="primary"
                      variant="outline"
                      title="Editar"
                      (onClick)="editDocumentation(doc)">
                    </patron-button>
                    <patron-button
                      iconName="bi-trash"
                      size="sm"
                      color="danger"
                      variant="outline"
                      title="Deletar"
                      (onClick)="deleteDocumentation(doc)">
                    </patron-button>
                  }
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <!-- Estado vazio -->
  @if (!loading && documentations.length === 0) {
    <div class="alert alert-info">
      <patron-icon name="bi-info-circle" class="me-2"></patron-icon>
      Nenhuma documentação vinculada a este chamado.
      @if (canWrite) {
        <patron-button
          iconName="bi-plus-circle"
          color="primary"
          size="sm"
          variant="outline"
          class="ms-2"
          (onClick)="openNewDocumentation()">
          Adicionar
        </patron-button>
      }
    </div>
  }

  <!-- Loading -->
  @if (loading) {
    <div class="text-center py-4">
      <patron-spinner size="sm" class="me-2"></patron-spinner>
      Carregando documentações...
    </div>
  }
</div>
